import { render, staticRenderFns } from "./NewVersionIntegration.vue?vue&type=template&id=33191ffa"
import script from "./NewVersionIntegration.vue?vue&type=script&lang=js"
export * from "./NewVersionIntegration.vue?vue&type=script&lang=js"
import style0 from "./NewVersionIntegration.vue?vue&type=style&index=0&id=33191ffa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports